export default `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 130 130">
  <path id="iconmonstr-facebook-4" d="M65,0a65,65,0,1,0,65,65A65,65,0,0,0,65,0ZM81.25,43.333H73.938c-2.914,0-3.521,1.2-3.521,4.214v6.619H81.25L80.118,65h-9.7v37.917H54.167V65H43.333V54.167H54.167v-12.5c0-9.582,5.043-14.582,16.407-14.582H81.25Z" fill="#9b9b9b"/>
</svg>
`
